import { preload } from '@utils'
import { useEffect } from 'react'

export default function usePreload(url, as, enable = true) {
  useEffect(() => {
    if (enable) preload(url, as)
  }, [url, enable, as])
}